<template>
  <MarkdownPost markdown-file="vibe-coding-vs-agentic-copilots.md" />
</template>

<script>
import MarkdownPost from '../MarkdownPost.vue'

export default {
  name: 'VibeCodingVsAgenticCopilots',
  components: {
    MarkdownPost
  }
}
</script>
